import React, { Component, Suspense } from "react";
import { replacestate } from "./../../../redux_store/actions/index";
import store from "./../../../redux_store/store/index";
import { withTranslation } from "react-multi-lang";
import {
  defalutreduxState,
  isMultitenant,
} from "./../../../custom_functions/Constance.jsx";
import $ from "jquery";
import "bootstrap";
import { withAlert } from "react-alert";
import { updateActiveUserTime } from "../../../custom_functions/Functions";
export const Taskmastercontext = React.createContext();
const createHistory = React.lazy(() => import("./../../general/History.jsx"));
const Menu = React.lazy(() => import("./../../Menu.jsx"));
const TestMaster = React.lazy(() =>
  import("./../../Base_Master/pages/PTestMaster.jsx")
);
//const TestMaster=React.lazy(()=>import('./../../user_management/pages/PTestMaster.jsx'))
const ApplicationHeader = React.lazy(() =>
  import("./../../general/ApplicationHeader.jsx")
);
const ApplicationFooter = React.lazy(() =>
  import("./../../general/ApplicationFooter.jsx")
);
export const Taskmaster_Context = React.createContext();
class PTestmaster extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    let Activatewidgets_Passdata = undefined;
    if (props?.location?.state !== undefined && props?.location?.state !== null) {
      Activatewidgets_Passdata = props?.location?.state?.testcode;
    }
    this.state = {
      MenuGroup: "UserManagement",
      ChildMenu: "SheetViewcss",
      PageName: this.props.t("Setup.Usergroup.IDS_LBL_USERS", { param: "" }),
      menuoption: 0,
      open: false,
      Menuselected: "",
      modalopen: false,
      ordercode: undefined,
      userrightdetails: undefined,
      Activatewidgets_Passdata,
      screenname: "TestMaster"
    };
    this.MainMeunClick = this.MainMeunClick.bind(this);
    this.ELNurl = window.appUrl.ELN;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidMount() {
    updateActiveUserTime();
    if (
      this.props.location.hash !== undefined &&
      this.props.location.hash.length > 0
    ) {
      let Sheetrun = this.props.location.hash.substring(
        2,
        this.props.location.hash.length - 1
      );
      if (
        Sheetrun !== undefined &&
        Sheetrun.split(":").length > 1 &&
        Sheetrun.split(":")[0] === "orderid"
      ) {
        let ordercode = Sheetrun.split(":")[1];
        this.setState({
          MenuGroup: "SheetView",
          PageName: this.props.t("menu.IDS_REGORDEREXE", {
            param: "",
          }),
          Menuselected: "SheetView_menu_group",
          ordercode: ordercode,
        });
      }
    }
  }

  MainMeunClick(Menu) {
    let PageName = "";
    let open = false;
    if (Menu === "SheetCreation") {
      PageName = this.props.t("Templates.Sheettemplates.IDS_LBL_SHEETCREATION", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetView") {
      PageName = this.props.t("menu.IDS_REGORDEREXE", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetSetting") {
      PageName = this.props.t("menu.IDS_SHEETSETTING", {
        param: "",
      });
    } else if (Menu === "AuditTrail") {
      PageName = this.props.t("AuditTrail.ID_AUDITTRAIL", {
        param: "",
      });
      open = false;
    } else if (Menu === "UserManagement") {
      PageName = this.props.t("UserManagement.ID_USERMANAGEMENT", {
        param: "",
      });
      open = false;
    } else if (Menu === "Dashboard") {
      PageName = this.props.t("Dashboard.IDS_LBL_DASHBOARD", {
        param: "",
      });
      open = false;
    } else if (Menu === "Masters") {
      PageName = this.props.t("Masters.Taskmaster.IDS_LBL_MASTERS", {
        param: "",
      });
      open = false;
    } else if (Menu === "DownloadReport") {
      PageName = this.props.t("Reports.IDS_LBL_SCREENNAME", {
        param: "",
      });
      open = false;
    }

    this.setState({
      MenuGroup: Menu,
      PageName: PageName,
      open: open || true,
      Menuselected: "",
    });
  }

  ChilMenuclick(Menu) {
    this.setState({ ChildMenu: Menu });
  }

  onlogoutSuccess(response) {
    store.dispatch(replacestate(defalutreduxState));
    setTimeout(() => {
      let tenantdomain = $.session.get("tenantdomain");

      if (tenantdomain !== undefined) {
        isMultitenant === 0
          ? this.props.history.push("/")
          : this.props.history.push("/#" + tenantdomain);

      } else {
        this.props.history.push("/")
      }
    }, 100);
  }

  onlogoutFailure(response) { }

  onredirectrights(objrights) {
    this.setState({ userrightdetails: objrights });
  }

  redirecttohome() {
    this.props.history.push("/Home");
  }

  onreset_Passdata() {
    if (
      this.props?.location?.state !== undefined &&
      this.props?.location?.state !== null
    ) {
      const history = createHistory;
      if (history.location !== undefined) {
        if (history.location.state && history.location.state.testcode) {
          let state = { ...history.location.state };
          delete state.testcode;
          history.replace({ ...history.location, state });
        }
      }
    }
    this.setState({
      Activatewidgets_Passdata: undefined
    });
  }

  render() {
    if (!$.session.get("User")) {
      setTimeout(() => {
        let tenantdomain = $.session.get("tenantdomain");
        if (this.props && this.props.history) {
          if (tenantdomain !== undefined) {
            isMultitenant === 0
              ? this.props.history.push("/")
              : this.props.history.push("/#" + tenantdomain);

          } else {
            this.props.history.push("/")
          }
        }
      }, 100);
      return <div></div>;
    }

    return (
      <div id="idElnBody">
        <Suspense fallback={<div></div>}>
          <Menu
            sendData={this.MainMeunClick}
            childmenuclick={this.ChilMenuclick.bind(this)}
            selected={this.state.Menuselected}
            menugroup={this.state.MenuGroup}
            screenname={this.state.screenname}
            redirectrights={this.onredirectrights.bind(this)}
          />
        </Suspense>
        <div id="bodycontent" className="d-flex flex-column">
          <Suspense fallback={<div></div>}>
            <ApplicationHeader
              values={this.state.helpid}
              onlogoutSuccess={this.onlogoutSuccess.bind(this)}
              redirecttohome={this.redirecttohome.bind(this)}
              onlogoutFailure={this.onlogoutFailure.bind(this)}
              PageName={this.state.PageName}
            />
          </Suspense>
          <Suspense fallback={<div></div>}>
            <Taskmastercontext.Provider value={{
              Activatewidgets_Passdata_Testcodes: this.state.Activatewidgets_Passdata,
              Onreset_Passdata: this.onreset_Passdata.bind(this)
            }}>
              <TestMaster rights={this.state.userrightdetails} />
            </Taskmastercontext.Provider>

          </Suspense>
        </div>
        <Suspense fallback={<div></div>}>
          <ApplicationFooter
            onlogoutSuccess={this.onlogoutSuccess.bind(this)}
            onlogoutFailure={this.onlogoutFailure.bind(this)}
            onforgot={this.props.onforgot}
          />
        </Suspense>
      </div>
    );
  }
}
export default withAlert()(withTranslation(PTestmaster));
